import { ANIMATION_IDENTIFIERS, DrawAnimationMechanicConfig } from '@Animation/types'
import { PLUS_3_CONFIG } from '../add-on-extra-draw/plus-3/config'
import { NoBackground } from '../base/background'
import { MI_MULTIPLIER_DICE_CONFIG } from '../add-on-multiplier/michigan-kicker/dice/config'
import { preLoadAssets, Light3Number, LightThreeNumberSelector } from '.'
import { LightThreeTexturePreloader } from './texture-loader'

export const LightThreeConfig: DrawAnimationMechanicConfig = {
  appSettings: {
    backgroundBaseColor: '#780D12FF',
    backgroundGlowColor: '#DFC5C6FF',
    backgroundUrl: '/animations/light-three/background.png',
  },
  numberSelector: LightThreeNumberSelector,
  background: NoBackground,
  foreground: null,
  kenoNumber: Light3Number,
  multiplierAnimationConfig: MI_MULTIPLIER_DICE_CONFIG,
  assetPreloader: preLoadAssets,
  extraDrawAnimationConfig: PLUS_3_CONFIG(ANIMATION_IDENTIFIERS.LIGHT_THREE),
  textureLoader: LightThreeTexturePreloader,
}
